import { INotFoundItem } from 'hooks/useNotFound'

export const getNotFoundContent = ({ language }): INotFoundItem =>
  ({
    fr: {
      main1: "La page que vous recherchez n'existe pas.",
      main2: 'The page you are looking for does not exist.',
      sub1: "Retour à l'accueil",
      sub2: 'Back Home'
    },
    en: {
      main1: 'The page you are looking for does not exist.',
      main2: "La page que vous recherchez n'existe pas.",
      sub1: 'Back Home',
      sub2: "Retour à l'accueil"
    }
  }[language])
